// ABOUTME: React Router future flags shared by test routers, matching the flags the app router opts into
// ABOUTME: Keeps MemoryRouter from emitting v7 future-flag warnings during tests

export const routerFuture = { v7_startTransition: true, v7_relativeSplatPath: true } as const;
